export class SaveServiceAttendanceAdjustmentRequest {
    closeAttendanceServiceId: number;
    exerciseId: number;
    serviceId: number;
    schoolId: number;
    month: number;
    year: number;
    status: number;
    concepServiceAdjustments: SaveServiceConceptAdjustmentRequest[];
}

export class SaveServiceConceptAdjustmentRequest {
    conceptServiceId: number;
    adjust: number;
}